import React, { Component } from 'react';
import '../css/print-data-page.css';
import AuthWrapper from "./authWrapper"
import PrintDataContent from "./print-data-content";
import { Nav, Navbar, NavItem } from "react-bootstrap";
import auth from "../modules/Auth0_setup";

export default class PrintDataPage extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <Navbar>
                    <Navbar.Header>
                        <Navbar.Brand>
                            SprintRay
                        </Navbar.Brand>
                    </Navbar.Header>
                    <Navbar.Collapse>
                        <Nav pullRight>
                            <NavItem onClick={auth.logout} href="/printDataLogin">
                                Logout
                            </NavItem>
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
                <AuthWrapper>
                    <PrintDataContent/>
                </AuthWrapper>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/print-data-page.js